const max_size = 1000
const thumbnail_size = 128

export const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        if (file.type.match(/image.*/)) {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = (readerEvent) => {
                var image = new Image()
                image.onload = () => {
                    // Resize the image
                    const canvas = document.createElement('canvas')
                    let width = image.width,
                        height = image.height

                    if (width > height) {
                        if (width > max_size) {
                            height *= max_size / width
                            width = max_size
                        }
                    } else {
                        if (height > max_size) {
                            width *= max_size / height
                            height = max_size
                        }
                    }
                    canvas.width = width
                    canvas.height = height
                    canvas
                        .getContext('2d')
                        .drawImage(image, 0, 0, width, height)
                    var dataUrl = canvas.toDataURL('image/png')

                    const thumbnailCanvas = document.createElement('canvas')

                    const maxLength = Math.max(...[width, height])

                    thumbnailCanvas.width = (width / maxLength) * thumbnail_size
                    thumbnailCanvas.height =
                        (height / maxLength) * thumbnail_size
                    thumbnailCanvas
                        .getContext('2d')
                        .drawImage(
                            image,
                            0,
                            0,
                            thumbnailCanvas.width,
                            thumbnailCanvas.height
                        )
                    const thumbnailDataUrl = thumbnailCanvas.toDataURL(
                        'image/png'
                    )
                    resolve({ imageData: dataUrl, thumbnailDataUrl })
                }
                image.onerror = (error) => reject(error)
                image.src = readerEvent.target.result
            }
            reader.onerror = (error) => reject(error)
        } else reject('File type is not valid...')
    })

export const toThumbnail64 = (imageSrc) =>
    new Promise((resolve, reject) => {
        var image = new Image()
        image.onload = () => {
            // Resize the image
            let width = image.width,
                height = image.height

            const thumbnailCanvas = document.createElement('canvas')

            const maxLength = Math.max(...[width, height])

            thumbnailCanvas.width = (width / maxLength) * thumbnail_size
            thumbnailCanvas.height = (height / maxLength) * thumbnail_size
            thumbnailCanvas
                .getContext('2d')
                .drawImage(
                    image,
                    0,
                    0,
                    thumbnailCanvas.width,
                    thumbnailCanvas.height
                )
            const thumbnailDataUrl = thumbnailCanvas.toDataURL('image/png')
            resolve(thumbnailDataUrl)
        }
        image.onerror = (error) => reject(error)
        image.src = imageSrc
    })

export const createPatternFromImage = (
    file,
    textureSize = 100,
    imageSize = 300
) =>
    new Promise((resolve, reject) => {
        var img = new Image()
        img.crossOrigin = 'Anonymous'

        img.onload = function () {
            const maxLength = Math.max(...[img.width, img.height])

            const canvas = document.createElement('canvas')

            var tempCanvas = document.createElement('canvas'),
                tCtx = tempCanvas.getContext('2d')

            tempCanvas.width = (img.width / maxLength) * textureSize
            tempCanvas.height = (img.height / maxLength) * textureSize

            const repeatNumberH = Math.round(
                imageSize / ((img.width / maxLength) * textureSize)
            )
            const repeatNumberV = Math.round(
                imageSize / ((img.height / maxLength) * textureSize)
            )
            canvas.width = tempCanvas.width * repeatNumberH
            canvas.height = tempCanvas.height * repeatNumberV

            tCtx.drawImage(
                img,
                0,
                0,
                img.width,
                img.height,
                0,
                0,
                tempCanvas.width,
                tempCanvas.height
            )

            // use getContext to use the canvas for drawing
            var ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            ctx.fillStyle = ctx.createPattern(tempCanvas, 'repeat')

            ctx.beginPath()
            ctx.rect(0, 0, canvas.width, canvas.height)
            ctx.fill()
            var dataUrl = canvas.toDataURL('image/png')
            resolve(dataUrl)
        }
        img.onerror = (error) => reject(error)
        img.src = file
    })

export const createPatternFromImageNew = (
    file,
    textureSize = 100,
    imageSize = 300,
    flipH = false,
    flipV = false
) =>
    new Promise((resolve, reject) => {
        var img = new Image()
        img.crossOrigin = 'Anonymous'

        img.onload = function () {
            const maxLength = Math.max(...[img.width, img.height])

            const canvas = document.createElement('canvas')

            var tempCanvas = document.createElement('canvas'),
                tCtx = tempCanvas.getContext('2d')

            var tempFlipedHCanvas = document.createElement('canvas'),
                tFlipedHCtx = tempFlipedHCanvas.getContext('2d')

            var tempFlipedVCanvas = document.createElement('canvas'),
                tFlipedVCtx = tempFlipedVCanvas.getContext('2d')

            tempCanvas.width = tempFlipedHCanvas.width = tempFlipedVCanvas.width =
                (img.width / maxLength) * textureSize
            tempCanvas.height = tempFlipedHCanvas.height = tempFlipedVCanvas.height =
                (img.height / maxLength) * textureSize

            const repeatNumberH = Math.round(
                imageSize / ((img.width / maxLength) * textureSize)
            )
            const repeatNumberV = Math.round(
                imageSize / ((img.height / maxLength) * textureSize)
            )
            canvas.width = tempCanvas.width * repeatNumberH
            canvas.height = tempCanvas.height * repeatNumberV

            tCtx.drawImage(
                img,
                0,
                0,
                img.width,
                img.height,
                0,
                0,
                tempCanvas.width,
                tempCanvas.height
            )
            tFlipedHCtx.translate(tempCanvas.width, 0)
            tFlipedHCtx.scale(-1, 1)
            tFlipedHCtx.drawImage(
                img,
                0,
                0,
                img.width,
                img.height,
                0,
                0,
                tempCanvas.width,
                tempCanvas.height
            )

            tFlipedVCtx.translate(0, tempCanvas.height)
            tFlipedVCtx.scale(1, -1)
            tFlipedVCtx.drawImage(
                img,
                0,
                0,
                img.width,
                img.height,
                0,
                0,
                tempCanvas.width,
                tempCanvas.height
            )

            // use getContext to use the canvas for drawing
            var ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)

            for (let hIndex = 0; hIndex < repeatNumberH; hIndex++) {
                for (let vIndex = 0; vIndex < repeatNumberV; vIndex++) {
                    let dx = tempCanvas.width * hIndex
                    let dy = tempCanvas.height * vIndex
                    if (flipH && hIndex % 2 == 0) {
                        ctx.drawImage(tempFlipedHCanvas, dx, dy)
                    } else if (flipV && vIndex % 2 == 0) {
                        ctx.drawImage(tempFlipedVCanvas, dx, dy)
                    } else ctx.drawImage(tempCanvas, dx, dy)
                }
            }

            var dataUrl = canvas.toDataURL('image/png')
            resolve(dataUrl)
        }
        img.onerror = (error) => reject(error)
        img.src = file
    })

export const createPatternFromImageForDrawing = (
    file,
    textureSize = 100,
    imageSize = 300,
    offsetH = 0,
    offsetV = 0
) =>
    new Promise((resolve, reject) => {
        var img = new Image()
        // img.crossOrigin = 'anonymous'
        img.setAttribute('crossorigin', 'anonymous'); // works for me


        img.onload = function () {
            const maxLength = Math.max(...[img.width, img.height])

            const canvas = document.createElement('canvas')

            var tempCanvas = document.createElement('canvas'),
                tCtx = tempCanvas.getContext('2d')

            tempCanvas.width = (img.width / maxLength) * textureSize
            tempCanvas.height = (img.height / maxLength) * textureSize

            const repeatNumberH = Math.round(
                imageSize / ((img.width / maxLength) * textureSize)
            )
            const repeatNumberV = Math.round(
                imageSize / ((img.height / maxLength) * textureSize)
            )
            canvas.width = tempCanvas.width * repeatNumberH
            canvas.height = tempCanvas.height * repeatNumberV

            tCtx.drawImage(
                img,
                0,
                0,
                img.width,
                img.height,
                0,
                0,
                tempCanvas.width,
                tempCanvas.height
            )

            // use getContext to use the canvas for drawing
            var ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)

            for (let hIndex = 0; hIndex <= repeatNumberH; hIndex++) {
                for (let vIndex = 0; vIndex <= repeatNumberV; vIndex++) {
                    let dx = tempCanvas.width * (hIndex - 1) + (offsetH * tempCanvas.width)
                    let dy = tempCanvas.height * (vIndex - 1) + (offsetV * tempCanvas.height)
                    ctx.drawImage(tempCanvas, dx, dy)
                }
            }

            var dataUrl = canvas.toDataURL('image/png')
            resolve(dataUrl)
        }
        img.onerror = (error) => reject(error)
        img.src = file
    })
